// import SearchIcon from '@assets/images/common/icon/search/search.svg';

import SearchIcon from '@src/assets/images/common/icon/search/SearchIcon';

interface SearchHistoryDropdownProps {
  items: string[];
  searchValue?: string;
  onItemClick: (item: string) => void;
  onItemRemove: (item: string) => void;
  onClearHistory: () => void;
}

const SearchHistoryDropdown = ({ items, onItemClick }: SearchHistoryDropdownProps) => {
  if (items.length === 0) {
    return null;
  }

  return (
    <div className='absolute inset-x-0 top-[105%] z-50 border border-gray-400 bg-white'>
      <div className='px-4 pb-2 pt-4 text-xs text-gray-450'>最近の検索</div>
      <div className='max-h-60 overflow-y-auto'>
        {items.map((item, index) => (
          <div
            key={index}
            className='group flex items-center transition-colors hover:bg-primary'
            onMouseDown={() => onItemClick(item)}
          >
            <button className='flex flex-1 items-center gap-2 px-4 py-3 text-left text-sm text-primary-800 transition-colors group-hover:text-white'>
              <SearchIcon
                className='size-[18px] shrink-0 transition-colors group-hover:brightness-0 group-hover:invert'
                width={18}
                height={18}
                color='#292929'
              />
              <span className='truncate text-sm'>{item}</span>
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SearchHistoryDropdown;
